import b from 'b_';
import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

// @ts-ignore
import COLORS from '../../design/ui-kit-colors.scss';
import { Button } from '../button/button';
import { H3, H4 } from '../header-text/header-text';
import { useIntl } from '../intl/context';
// @ts-ignore
import Modal from '../modal/modal';
import { ModalProps } from '../modal/types';
import { PersonalAgreementLink } from '../personal-agreement/linksData';
import { PersonalAgreement } from '../personal-agreement/personal-agreement';
import Text from '../text/text';

import './modal-offer.scss';

enum VIEW {
    STRICT = 'strict',
    SOFT = 'soft',
}

interface Props extends ModalProps {
    children?: ReactElement;
    headerText: string;
    descriptionText: string;
    buttonText: string;
    view: VIEW;
    personalAgreementLinkConfig: PersonalAgreementLink[];
    onSubmit: () => void;
    progress?: boolean;
}

export const ModalOffer = (props: Props) => {
    const {
        children,
        headerText,
        descriptionText,
        buttonText,
        personalAgreementLinkConfig,
        view,
        onSubmit,
        progress,
        ...modalProps
    } = props;
    const buttonSize = view === VIEW.SOFT ? Button.SIZE.L : Button.SIZE.M;
    const HeaderComponent = view === VIEW.SOFT ? H3 : H4;
    const intl = useIntl();

    return (
        <Modal mix="modal-offer__modal" {...modalProps}>
            <div className={b('modal-offer', { view })}>
                <div className={b('modal-offer', 'header', { view })}>
                    <HeaderComponent id={headerText} />
                </div>
                <div className={b('modal-offer', 'description', { view })}>
                    <Text color={COLORS.black800} id={descriptionText} size={Text.SIZE.XL} />
                </div>
                {children}
                <Button
                    className="modal-offer__button"
                    onClick={onSubmit}
                    progress={progress}
                    rounded={view === VIEW.SOFT}
                    size={buttonSize}
                >
                    <FormattedMessage id={buttonText} />
                </Button>
                <div className="modal-offer__link">
                    <PersonalAgreement
                        buttonText={intl.formatMessage({ id: buttonText })}
                        linksConfig={personalAgreementLinkConfig}
                    />
                </div>
            </div>
        </Modal>
    );
};

ModalOffer.VIEW = VIEW;
